import * as React from "react";
import { observer, inject } from "mobx-react";

import { SessionStore } from "src/stores/SessionStore";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faSignOutAlt, faUser } from "@fortawesome/free-solid-svg-icons";

import NewPasswordDialog from "./common/NewPasswordDialog";

interface Props {
    sessionStore?: SessionStore;
    showSideBar: boolean;
}
interface State {
    showUserNav: boolean;
    isShown: boolean;
}

@inject("sessionStore")
@observer
export default class MainUser extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            showUserNav: false,
            isShown: false
        };
    }

    mouseOverUser = () => {
        this.setState({ showUserNav: true });
    };

    mouseOutUser = () => {
        this.setState({ showUserNav: false });
    };

    toggle = (): void => {
        this.setState(prevState => ({
            isShown: !prevState.isShown
        }));
    };

    onClickLogout = (): void => {
        this.props.sessionStore!.logout();
    };

    render() {
        const { sessionStore } = this.props;
        if (!sessionStore) {
            throw new Error(" ** No session Store **");
        }

        return (
            <div className={`user btn-group ${this.props.showSideBar ? `showSideBar` : ``} `} onMouseLeave={this.mouseOutUser}>
                <ul className={"submenu " + (this.state.showUserNav === true ? " show" : "")} onMouseLeave={this.mouseOutUser}>
                    <li>
                        <a onClick={this.toggle} title="Change Password">
                            <div className="icon">
                                <FontAwesomeIcon icon={faKey} />
                            </div>
                            <div className="title">Change Password</div>
                        </a>
                    </li>
                    <li>
                        <a onClick={this.onClickLogout}>
                            <div className="icon">
                                <FontAwesomeIcon icon={faSignOutAlt} />
                            </div>
                            <div className="title">Log out</div>
                        </a>
                    </li>
                </ul>
                <a className="button" onMouseEnter={this.mouseOverUser} aria-haspopup="true" aria-expanded="false">
                    <div className="icon">
                        <FontAwesomeIcon icon={faUser} />
                    </div>
                    <div className="username">{sessionStore.fullName}</div>
                </a>
                {this.state.isShown && <NewPasswordDialog toggleFunction={this.toggle} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/user.tsx